import { Routes } from '@angular/router';
import { VerificationSummaryComponent } from './verification-summary.component';

/**
 * Created by Arturo Campos on 30/11/18.
 */
const routes: Routes = [{
    path: 'verification',
    component: VerificationSummaryComponent,
    data: { impersonationAllowed: true }
}];

export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/verification/verification-summary.routing.ts